import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuthLayout from '../../features/auth/AuthLayout';
import LogoHeader from '../../components/LogoHeader';
import AuthCard from '../../features/auth/AuthCard';
import RegistrationForm from '../../features/auth/registration/RegistrationForm';
import RegistrationSuccess from '../../features/auth/registration/RegistrationSuccess';
import ConfirmEmailForm from '../../features/auth/registration/ConfirmEmailForm';
import { RegistrationFormData } from '../../features/auth/registration/schema';
import { useRegistration } from '@/hooks/useRegistration';

const Registration: React.FC = () => {
  const { t } = useTranslation();
  const {
    signUp,
    confirmCode,
    resendCode,
    step,
    submittedEmail,
    approved,
    resendCooldown,
    isLoading: isAuthLoading,
    error: authError,
    clearError: clearAuthError,
  } = useRegistration();

  const handleSubmit = async (data: RegistrationFormData) => {
    await signUp(data);
  };

  const renderStep = () => {
    switch (step) {
      case 'confirm_code':
        return (
          <>
            <ConfirmEmailForm
              email={submittedEmail}
              onSubmit={confirmCode}
              onResend={resendCode}
              resendCooldown={resendCooldown}
              error={authError}
              isLoading={isAuthLoading}
              onClearError={clearAuthError}
            />
            <p className="mt-4 text-center text-sm text-gray-600">
              <Link
                to={`/confirm-registration?email=${encodeURIComponent(submittedEmail)}`}
                className="font-medium text-blue-700 hover:underline"
              >
                {t('auth.confirm_email.confirm_later')}
              </Link>
            </p>
          </>
        );
      case 'success':
        return <RegistrationSuccess approved={approved} />;
      default:
        return (
          <RegistrationForm
            onSubmit={handleSubmit}
            error={authError}
            isLoading={isAuthLoading}
            onClearError={clearAuthError}
          />
        );
    }
  };

  return (
    <main>
      <AuthLayout>
        <LogoHeader />
        <AuthCard>{renderStep()}</AuthCard>
      </AuthLayout>
    </main>
  );
};

export default Registration;
